import Immutable from 'seamless-immutable';
import { createReducer, completeReducer, completeState, onReadValue } from 'redux-recompose';

import { actions } from './actions';

const stateDescription = {
  settings: null,
  settingsLoading: true,
  tenant: '',
  gcpTenantId: '',

  storeSelected: 1
};

const initialState = completeState(stateDescription, ['settingsLoading']);

const reducerDescription = {
  primaryActions: [actions.GET_SETTINGS, actions.GET_TENANT],
  override: {
    [actions.SET_STORE_SELECTED]: onReadValue(),
    [actions.SET_GCP_TENANT_ID]: onReadValue()
  }
};

export default createReducer(new Immutable(initialState), completeReducer(reducerDescription));
